import { TFeature } from 'shared/map-search/types/map';

interface IGetBalloonManagerByFeatureProps {
  feature: TFeature;
  balloonManager: YMaps.BalloonManager;
  balloonPromoManager: YMaps.BalloonPromoManager;
}

/**
 * @description
 * Проверяет, к какому manager относится пин
 */
export const getBalloonManagerByFeature = ({
  feature,
  balloonManager,
  balloonPromoManager,
}: IGetBalloonManagerByFeatureProps) => {
  if (feature.properties.isPulsedGlow) {
    return balloonPromoManager;
  }

  return balloonManager;
};
